import { render } from "./EmergencyAttachmentModal.vue?vue&type=template&id=e20577d4&scoped=true&ts=true"
import script from "./EmergencyAttachmentModal.ts?vue&type=script&lang=ts"
export * from "./EmergencyAttachmentModal.ts?vue&type=script&lang=ts"

import "./EmergencyAttachmentModal.scss?vue&type=style&index=0&id=e20577d4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e20577d4"]])

export default __exports__